// 域名配置文件
// 根据不同域名设置不同的网站标题和备案信息

// 配置映射表
const domainConfig = {
  'douyinpay.top': {
    title: '际付密码 - 品质生鲜购物平台',
    company: '际付密码（江西）科技有限公司',
    icpCode: '赣ICP备2025077564号-6',
    icpLink: 'http://beian.miit.gov.cn',
    logo: require('../assets/images/logo1.png'),
    logoText: '际付密码'
  },
  'www.douyinpay.top': {
    title: '际付密码 - 品质生鲜购物平台',
    company: '际付密码（江西）科技有限公司',
    icpCode: '赣ICP备2025077564号-6',
    icpLink: 'http://beian.miit.gov.cn',
    logo: require('../assets/images/logo1.png'),
    logoText: '际付密码'
  },
  'zf.douzhiwei.com.cn': {
    title: '抖支微 - 品质生鲜购物平台',
    company: '抖支微（上海）信息技术有限公司',
    icpCode: '沪ICP备2025134111号-1',
    icpLink: 'http://beian.miit.gov.cn',
    logo: require('../assets/images/logo2.png'),
    logoText: '抖支微'
  },
  'aetsx.com': {
    title: '找客买单码',
    company: '找客买单码',
    icpCode: '鲁ICP备16039239号-9',
    icpLink: 'http://beian.miit.gov.cn',
    logo: require('../assets/images/logo3.png'),
    logoText: '找客买单码'
  },
  '192.168.1.179': {
    title: '小兔鲜 - 本地网络环境',
    company: '本地网络测试',
    icpCode: '测试备案号',
    icpLink: '#',
    logo: require('../assets/images/logo.png'),
    logoText: '网络测试'
  },
  localhost: {
    title: '小兔鲜 - 本地开发环境',
    company: '本地开发测试',
    icpCode: '测试备案号',
    icpLink: '#',
    logo: require('../assets/images/logo.png'),
    logoText: '本地开发'
  }
}

// 获取当前域名
const getCurrentDomain = () => {
  if (typeof window === 'undefined') {
    return 'localhost'
  }
  const hostname = window.location.hostname
  return hostname
}

// 获取配置
const getConfig = () => {
  const domain = getCurrentDomain()
  return domainConfig[domain] || domainConfig.localhost
}

// 应用配置到页面
const applyConfig = () => {
  if (typeof window === 'undefined') {
    return
  }

  const config = getConfig()

  // 设置网站标题
  document.title = config.title

  // 设置备案信息
  const companyElement = document.getElementById('name')
  const icpCodeElement = document.getElementById('icpCode')
  const icpLinkElement = document.getElementById('icpLink')

  if (companyElement) {
    companyElement.textContent = config.company
  }

  if (icpCodeElement) {
    icpCodeElement.textContent = config.icpCode
  }

  if (icpLinkElement) {
    icpLinkElement.href = config.icpLink
  }
}

export default {
  getConfig,
  applyConfig
}
